export function fixUrl(url) {
   // check if url is empty or not a string
   if (!url) {
      return url;
   }
   if (typeof url !== 'string') {
      return false;
   }

   // check if the url not start with http fiox it
   if (!url?.startsWith('http')) {
      // check if url start with //
      if (url.startsWith('//')) {
         // add https to url
         url = 'https:' + url;
      } else {
         // add https:// to url
         url = 'https://' + url;
      }
   }
   return url;
}
